/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.href === 'https://primopassi.com/pages/registration-page') {
   console.log('Document is ready');

  var intervalId = setInterval(function () {
    // Get the shadow host element
    var shadowHost = document.querySelector('form-embed#app-embed');

    // Ensure the shadow host element exists
    if (shadowHost) {
      // Access the shadow root
      var shadowRoot = shadowHost.shadowRoot;

      // Query the element inside the shadow root
      var element = shadowRoot.querySelector('._textBody_2aowh_10 p');
      var phoneFieldParent = shadowRoot.querySelector('._formPhoneInputContainer_1ym3p_6');
      var phoneField = shadowRoot.querySelector('._formPhoneInputContainer_1ym3p_6 input');
      // Change the text content of the element
      if (element) {
        element.textContent = 'We will use the information provided on this page only to contact you if there is a safety alert or recall for this product. We will not sell, rent, or share your personal information. If you register on this Web site you do not need to fill out the card that came with your product.';
        console.log('Text content updated successfully');
        // Clear the interval once the element is found and updated
        phoneField.value = 'xxxx-xxxx';
        phoneFieldParent.style.display = 'none';
        clearInterval(intervalId);
      } else {
        console.log('Element not found');
      }
    } else {
      console.log('Shadow host not found');
    }
  }, 300); // Check every 1 second
  }
});


